import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logoCongresso from '../assets/logo-bahia-vascular-login.png';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [showEsqueci, setShowEsqueci] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await auth.login(username, password);
      navigate('/');
    } catch (err) {
      setError('Falha no login. Verifique seu usuário e senha.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-shell">
        <section className="login-brand-panel" aria-label="CBACV 2026">
          <div className="login-brand-content">
            <span className="login-edition">CBACV 2026</span>
            <h1>A ciência vascular<br />encontra novos caminhos.</h1>
            <p>
              Plataforma oficial de avaliação dos trabalhos científicos do
              46º Congresso de Angiologia e de Cirurgia Vascular.
            </p>
            <div className="login-brand-tags" aria-label="Categorias avaliadas">
              <span>Temas Livres</span>
              <span>Pôsteres</span>
              <span>Temas Correlatos</span>
            </div>
          </div>
          <span className="login-brand-signature">Bahia Vascular</span>
        </section>

        <section className="login-box">
          <div className="login-heading">
            <img src={logoCongresso} alt="Bahia Vascular 2026" className="login-logo" />
            <div>
              <span className="login-eyebrow">Portal do avaliador</span>
              <h2>{showEsqueci ? 'Recuperar acesso' : 'Bem-vindo'}</h2>
              {!showEsqueci && <p>Acesse com suas credenciais para continuar.</p>}
            </div>
          </div>

        {!showEsqueci ? (
          <>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label htmlFor="username">Usuário</label>
                <input
                  type="text"
                  id="username"
                  placeholder="Digite seu usuário"
                  autoComplete="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value.toLowerCase().trim())}
                  required
                />
              </div>
              <div className="input-group">
                <label htmlFor="password">Senha</label>
                <div className="password-wrapper">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    placeholder="Digite sua senha"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                    tabIndex={-1}
                  >
                    {showPassword ? (
                      // Olho fechado
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      // Olho aberto
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>
              {error && <p className="error-message">{error}</p>}
              <button type="submit" className="login-button">
                <span>Entrar na plataforma</span>
                <span aria-hidden="true">→</span>
              </button>
            </form>
            <button
              className="login-esqueci"
              onClick={() => setShowEsqueci(true)}
            >
              Esqueci minha senha
            </button>
          </>
        ) : (
          <div className="esqueci-box">
            <div className="esqueci-icon">🔑</div>
            <h3 className="esqueci-titulo">Recuperação de senha</h3>
            <p className="esqueci-texto">
              Para redefinir sua senha, entre em contato com o administrador do sistema:
            </p>
            <div className="esqueci-contato">
              <span className="esqueci-nome">👤 Nasser Mahfouz</span>
              <span className="esqueci-info">Administrador do CBACV 2026</span>
            </div>
            <p className="esqueci-instrucao">
              Informe seu <strong>nome de usuário</strong> ao administrador e ele irá redefinir sua senha pelo painel de avaliadores.
            </p>
            <button
              className="login-button"
              onClick={() => setShowEsqueci(false)}
            >
              ← Voltar ao Login
            </button>
          </div>
        )}
          <p className="login-support">Ambiente seguro para a comissão científica</p>
        </section>
      </div>
    </div>
  );
}

export default Login;
